import { SummarizerConfig } from '../../types/summarizer';

export const podcastSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'podcast-summarizer',
  title: 'Podcast Summarizer',
  description: 'Get AI-powered summaries of podcast episodes from any platform',
  version: '1.0.0',

  // Categorization
  category: 'audio',
  tags: ['podcast', 'audio', 'spotify', 'apple-podcasts', 'streaming'],

  // Input configuration
  inputs: {
    file: {
      enabled: true,
      acceptedTypes: ['.mp3', '.wav', '.m4a', '.aac', '.ogg'],
      maxSize: 200 * 1024 * 1024, // 200MB in bytes
      placeholder: 'Upload podcast audio file',
      multiple: false,
      helpText: 'Supports audio files up to 200MB or direct links from major podcast platforms.',
      showHelpText: true,
    },
    url: {
      enabled: true,
      placeholder: 'Enter podcast episode URL',
      // validation: /spotify\.com\/episode|podcasts\.apple\.com|soundcloud\.com|anchor\.fm|castbox\.fm|overcast\.fm/,
      examples: [
        'https://open.spotify.com/episode/...',
        'https://podcasts.apple.com/podcast/...',
        'https://soundcloud.com/podcast-name/episode',
      ],
      showExamples: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
    repurpose: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'podcast',
    timeout: 180000, // 3 minutes for audio processing
  },

  // UI customization (Level 2: Custom styling)
  ui: {
    // Basic styling
    primaryColor: '#1db954', // Spotify green
    secondaryColor: '#1ed760',
    icon: '🎧',

    // Custom styles (Level 2)
    customStyles: {
      container: '',
      inputArea: 'bg-white shadow-lg rounded-xl',
      button:
        'bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-all',
    },

    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 1024, // 1MB minimum
    maxSize: 200 * 1024 * 1024, // 200MB in bytes
    allowedDomains: [
      'open.spotify.com',
      'podcasts.apple.com',
      'soundcloud.com',
      'anchor.fm',
      'castbox.fm',
      'overcast.fm',
    ],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
